import React from "react"
import * as PropTypes from "prop-types"
import { VideoJsonLd } from "next-seo"
import { useLocale, useT } from "react-polyglot-hooks"

export default function TvSpotVideoJsonLd({ videoId }) {
  const t = useT()
  const locale = useLocale()

  if (!videoId) return null

  return (
    <VideoJsonLd
      name={t("common.video.name")}
      description={t("common.video.description")}
      contentUrl={`https://www.youtube.com/watch?v=${videoId}`}
      embedUrl={`https://www.youtube.com/embed/${videoId}`}
      thumbnailUrls={[`https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`]}
      duration={t("common.video.duration")}
      uploadDate={t("common.video.uploaded")}
      publisher={{
        "@type": "Organization",
        name: "Swipcar",
        url: `https://swipcar.com/${locale}`
      }}
    />
  )
}

TvSpotVideoJsonLd.propTypes = {
  videoId: PropTypes.string
}

TvSpotVideoJsonLd.defaultProps = {
  videoId: null
}
